// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Ka6O","buttons":"Footer_buttons__3KuDH"};